import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Flex } from '@mantine/core';
import { Navbar } from './Navbar';
import { Breadcrumbs } from './Breadcrumbs';

export const Layout = () => {
  return (
    <Flex
      bg="var(--mantine-color-gray-light)"
      py="0"
      mih="100%"
      dir="column"
      justify="center"
    >
      <Container maw={1400} w="100%" bg="white" p={0}>
        <Navbar />
        <Box px="lg" pt="md">
          <Breadcrumbs />
        </Box>
        <Box p="lg">
          <Outlet />
        </Box>
      </Container>
    </Flex>
  );
};
